import { parseHtml } from '@healthhub/react-ui';
import { Typography } from 'antd';
import type { KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { RetrieveDataError } from '@shared/assets';
import { Button } from '@shared/components/Button';

const { Text } = Typography;

interface IDisplayErrorProps {
  buttonText?: null | string;
  hideBackButton?: boolean;
  imgErrorUrl?: string;
  message?: null | string;
  onBackClick?: () => void;
  onClick?: () => void;
  onRefreshClick?: () => void;
}

const DisplayError = ({
  buttonText,
  hideBackButton,
  imgErrorUrl,
  message,
  onBackClick,
  onClick,
  onRefreshClick,
}: IDisplayErrorProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('hsg');

  const onRefresh = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(0);
    }
  };

  const navigateBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  const onClickBackNavigation = () => {
    navigateBack();
  };

  const onKeyDownBackNavigation = (e: KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      navigateBack();
    }
  };

  if (!message) {
    return null;
  }

  const renderMessage = () => {
    if (message) {
      return <Text className="text-sm w-3/5 text-center font-semibold">{parseHtml(message)}</Text>;
    }

    return null;
  };

  return (
    <div className="px-4">
      {!hideBackButton && (
        <Button
          className="mb-5 block text-start text-theme-600"
          onClick={onClickBackNavigation}
          onKeyDown={onKeyDownBackNavigation}
          variant="link"
        >
          {t('back')}
        </Button>
      )}
      <div className="flex flex-col items-center gap-6 py-12">
        {!!imgErrorUrl && <img alt="" className="h-52" src={imgErrorUrl} />}
        {!imgErrorUrl && <img alt="" className="h-52" src={RetrieveDataError} />}
        {renderMessage()}
        {buttonText && onRefreshClick ? (
          <Button className="json-checked w-full" onClick={onRefreshClick}>
            {parseHtml(buttonText)}
          </Button>
        ) : (
          <Button className="json-checked w-full" onClick={onRefresh}>
            {t('refresh')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DisplayError;
